import { sha256Hex } from "./crypto.js";
import { ChallengeSdkError } from "./errors.js";
const FINGERPRINT_FACTORIES = {
    ua: () => navigator.userAgent ?? "na",
    lang: () => navigator.language ?? "na",
    tz: () => Intl.DateTimeFormat().resolvedOptions().timeZone ?? "na",
    platform: () => navigator.platform ?? "na",
    screen: () => getScreenValue(),
    webgl: () => getWebGlRenderer(),
};
const DEFAULT_FINGERPRINT_FIELDS = Object.keys(FINGERPRINT_FACTORIES);
export async function collectBrowserFingerprint(fields) {
    ensureBrowserRuntime();
    const activeFields = Array.isArray(fields) && fields.length
        ? fields.filter((field) => typeof field === "string" && field in FINGERPRINT_FACTORIES)
        : DEFAULT_FINGERPRINT_FIELDS;
    const raw = activeFields
        .map((field) => `${field}=${FINGERPRINT_FACTORIES[field]()}`)
        .join("|");
    return {
        raw,
        hash: await sha256Hex(raw),
    };
}
function ensureBrowserRuntime() {
    if (typeof window === "undefined" || typeof navigator === "undefined" || typeof screen === "undefined") {
        throw new ChallengeSdkError("Challenge SDK must run in a browser runtime.", "BROWSER_RUNTIME_REQUIRED");
    }
}
function getScreenValue() {
    return `${screen.width}x${screen.height}x${screen.colorDepth}`;
}
function getWebGlRenderer() {
    try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl") ??
            canvas.getContext("experimental-webgl");
        if (!gl) {
            return "na";
        }
        const webgl = gl;
        const extension = webgl.getExtension("WEBGL_debug_renderer_info");
        if (!extension) {
            return "na";
        }
        return webgl.getParameter(extension.UNMASKED_RENDERER_WEBGL) ?? "na";
    }
    catch {
        return "na";
    }
}
